
import {defineComponent, PropType} from "vue";
import ModalDialog from "../ob1/ModalDialog.vue";
import {Gallery, Section} from "../../../orange/broadband/internet/showcase/components/models/SingleOfferDetail";

export default defineComponent({
    name: "ThreeColumnsEditoPopin",
    components: {ModalDialog},
    props: {
        popinId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        visual: {
            type: Object as PropType<Gallery | null>,
            required: false,
            default: null
        },
        sections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        mentions: {
            type: Object as PropType<string | null>,
            required: false,
            default: null
        },
        firstColumnSections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        secondColumnSections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        thirdColumnSections: {
            type: Array as PropType<Array<Section>>,
            required: true
        }
    },
});
